import * as XLSX from 'xlsx';

export default {
  methods: {
    createExcelHeaders(headers, titleItem) {
      const excelHeaders = headers.map((header) => header?.[titleItem]);
      return {
        excelHeaders,
      };
    },
    createExcelData(data, items) {
      const excelData = [...data]?.map((dataItem) => {
        return [...items].map((eachItem) => {
          return dataItem?.[eachItem];
        });
      });
      return { excelData };
    },
    exportToExcel(headers, data, headerTitle, documentFileName = 'report') {
      const filterdHeaders = [...headers]?.filter(
        (header) => header?.[headerTitle] !== '' && header.value !== 'actions',
      );


      const transformedData = data.map(item => {
        const newItem = { ...item };

        if (newItem.missionRank >= 0) {
          const rankMap = {
            0: 'سفید',
            1: 'سبز',
            2: 'زرد',
            3: 'قرمز'
          };
          newItem.missionRank = rankMap[newItem.missionRank] || newItem.missionRank;
        }

        return newItem;
      });


      const { excelHeaders } = this.createExcelHeaders(filterdHeaders, headerTitle);
      const excelHeaderValues = filterdHeaders.map((item) => item.value);
      const { excelData } = this.createExcelData(transformedData, excelHeaderValues);
      // Combine headers and data
      const worksheetData = [excelHeaders, ...excelData];
      // // Create worksheet
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      // // Create workbook and append worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'sheet1');
      // // Export to Excel file
      XLSX.writeFile(workbook, `${documentFileName}.xlsx`);
    },
  },
};
